<template>
  <div class="container">
    <Sidebar class="sidebar">
      <div class="sidebar-content">
        <header class="header">
          <h2 class="fn-title-1 title">Підписати документи</h2>
        </header>

        <DocumentTabs
          class="tab-bar"
          :documents="documents"
          :activeId="activeId"
          v-on:document-click="documentSelect"
        />

        <button
          :disabled="documents.length === 0"
          class="main-btn second-color large-btn next-btn btn"
          v-on:click="triggerSignAllDocuments"
        >
          Підписати всі документи
        </button>

        <button
          class="large-btn second-color second-btn btn add-people"
          v-on:click="openShareModal"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 21V19C4 17.8954 4.89543 17 6 17H18C19.1046 17 20 17.8954 20 19V21"
              stroke="#00050A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9C8 6.79086 9.79086 5 12 5"
              stroke="#00050A"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              d="M16 3V7"
              stroke="#00050A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18 5L14 5"
              stroke="#00050A"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Надати доступ для підпису
        </button>

        <button
          class="main-btn second-color large-btn next-btn btn"
          v-on:click="handleDocumentsSubmit"
        >
          Надіслати в банк
        </button>
        <div
          class="error"
          v-if="submitted && !isAllSigned"
        >
          Підписано не всі документи
        </div>
        <div
          class="error"
          v-if="submitted && documents.length === 0"
        >
          Документи відсутні
        </div>
      </div>
    </Sidebar>

    <div class="content">
      <DocumentsWorkspace
        v-if="activeDocument && !showAllSigned"
        :key="fileUri"
        :document="activeDocument"
        :documentUri="fileUri"
        :forward="forward"
        :backward="backward"
        v-on:sign="triggerSignActiveDocument"
        v-on:share="sendToEmail"
        v-on:download="downloadSigned"
      />

      <DocumentsSuccess v-if="showAllSigned" />

      <DocumentsSignModal
        :id="signModalId"
        :authorities="authorities"
        v-on:submit="signFunction"
      />

      <DocumentShareModal :id="shareModalId" v-on:submit="signShare" />

      <DocumentsOtpModal
        :id="otpModalId"
        :message="otpMessage"
        :timeout="60"
        v-on:submit="optSignConfirm"
        v-on:retry="otpSignRequest"
      />
    </div>

    <div v-if="isLoading" class="loader">
      <img src="@/assets/loader.svg" alt="loader" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as Sentry from '@sentry/browser'

import Sidebar from "../components/Sidebar/Sidebar.vue";
import DocumentTabs from "../components/DocumentTabs/DocumentTabs.vue";
import DocumentsWorkspace from "../components/DocumentsWorkspace/DocumentsWorkspace.vue";
import DocumentsSignModal from "../components/DocumentsSignModal/DocumentsSignModal.vue";
import DocumentShareModal from "../components/DocumentShareModal/DocumentShareModal.vue";
import DocumentsOtpModal from "../components/DocumentsOtpModal/DocumentsOtpModal.vue";
import DocumentsSuccess from "../components/DocumentsSuccess/DocumentsSuccess.vue";

import { getCertificateAuthorities, signDocumentFlow } from "../cipher/api";

const API = `${process.env.VUE_APP_BASE_URL}api/v1/`;

const STORAGE_KEY = "SESSION";

let otpCurrentCount = Number(sessionStorage.getItem('otpTimer')) || 60

const timeOut = (count) => {
  sessionStorage.setItem('otpTimer', String(count));
}

let timerId = setInterval(() => {
  timeOut(otpCurrentCount);
  if (otpCurrentCount) {
    otpCurrentCount -= 1
  } else {
    clearInterval(timerId)
  }
}, 1000)

const clearSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

const saveSession = (session) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

const getToken = () => {
  // const session = {
  //   "journal_id": 208,
  //   "journal_ref": "af74b789ad91018c0553dda200015814",
  //   "name": "Терентій",
  //   "email": "test@test.com",
  //   "phone": "+380(99)1002233",
  //   "token": ""
  // };

  const localSession = sessionStorage.getItem(STORAGE_KEY);
  const session = localSession ? JSON.parse(localSession) : {};

  const { token } = session;

  return token;
};

const getSession = async (ref) => {
  if (getToken()) {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY));
  }

  const { data } = await callApi(`${API}customer/kep/${ref}`);

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  return data;
};

const callApi = async (
  endpoint,
  data,
  method = "GET",
  headers = {},
) => {
  const isFormData = data instanceof FormData;
  const isFile = data instanceof Blob;

  const token = getToken();

  const request = {
    headers: {
      Accept: "application/json",
      ...(isFormData || isFile ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    method,
  };

  if (data && (isFormData || isFile)) {
    Object.assign(request, { body: data });
  } else if (data) {
    Object.assign(request, { body: JSON.stringify(data) });
  }

  const responsePromise = await fetch(endpoint, request);
  const responseClone = responsePromise.clone();

  let responseData;

  try {
    responseData = await responsePromise.json();
  } catch (e) {
    return responseClone;
  }

  const { error } = responseData;

  if (error || responsePromise.status >= 400) {
    if ([1808, 1002].includes(error.code)) { // logout
      clearSession();
      location.reload();
    }

    // console.error(error.message);
    throw new Error(error.message);
  }

  return responseData;

};

const requestOtp = async (ref) => {
  const response = await callApi(`${API}customer/kep/otp/send/${ref}`);
  return response.data;
};

const requestOtpConfirmation = async (ref, otp_ref, otp_code) => {
  const response = await callApi(
    `${API}customer/kep/otp/confirm/${ref}`,
    {
      otp_ref,
      otp_code,
    },
    "POST"
  );

  return response.data.token;
};

const getDocumentsList = async () => {
  const response = await callApi(`${API}customer/kep/document/list`);
  return response.data.documents;
};

const getDocument = async (id) => {
  const response = await callApi(
    `${API}customer/kep/document/${id}`,
    null,
    "GET"
  );

  const file = await response.blob();
  return file;
};

const getSignedDoc = async (id) => {
  const response = await callApi(
    `${API}customer/kep/document/${id}/signed`,
    null,
    "GET"
  );

  const file = await response.blob();
  return file;
};

const uploadSignedFile = async (id, file) => {
  const data = new FormData();
  data.append("file_id", id);
  data.append("file", file);

  const response = await callApi(
    `${API}customer/kep/document/upload`,
    data,
    "POST"
  );

  return response.data;
};

const sendInviteEmail = async (data) => {
  const response = await callApi(
    `${API}customer/kep/send-invite`,
    data,
    "POST"
  );

  return response.data;
};

const sendFilesToEmail = async () => {
  const response = await callApi(
    `${API}customer/kep/document/send-to-email`,
    undefined,
    "POST"
  );

  return response.data;
};

const statusChange = async (status) => {
  try {
    await callApi(
      `${API}customer/kep/status`,
      {
        status_id: status,
      },
      "POST"
    );
  } catch (e) {
    console.error(e);
  }
};

const SIGN_MODAL_ID = "SIGN_MODAL_ID";
const SHARE_MODAL_ID = "SHARE_MODAL_ID";
const OTP_MODAL_ID = "OTP_MODAL_ID";

export default {
  name: "DocumentsSign",
  components: {
    Sidebar,
    DocumentTabs,
    DocumentsWorkspace,
    DocumentsSignModal,
    DocumentShareModal,
    DocumentsOtpModal,
    DocumentsSuccess,
  },
  setup() {},
  computed: {
    activeDocument(vm) {
      return vm.documents.find((doc) => doc.id === vm.activeId);
    },
    fileUri(vm) {
      return vm.file ? window.URL.createObjectURL(vm.file) : "about:blank";
    },
    signedFileUri(vm) {
      return vm.signedFile
        ? window.URL.createObjectURL(vm.signedFile)
        : "about:blank";
    },
    isActiveDocumentSigned(vm) {
      const { p7s, signatures } = vm.activeDocument;

      return (signatures && signatures.length > 0) || (p7s && p7s.length > 0);
    },
    isAllSigned(vm) {
      return vm.documents.reduce((acc, document) => {
        const { p7s, signatures } = document;

        return (
          acc &&
          ((signatures && signatures.length > 0) || (p7s && p7s.length > 0))
        );
      }, true);
    },
    forward(vm) {
      const index = vm.documents.indexOf(vm.activeDocument);
      if (index < vm.documents.length - 1) {
        return () => vm.documentSelect(vm.documents[index + 1].id);
      }
      return null;
    },
    backward(vm) {
      const index = vm.documents.indexOf(vm.activeDocument);
      if (index > 0 && vm.documents.length > 0) {
        return () => vm.documentSelect(vm.documents[index - 1].id);
      }
      return null;
    },
  },
  methods: {
    async documentSelect(id) {
      this.showAllSigned = false;

      if (this.activeId !== id) {
        this.activeId = id;

        this.file = null;
        this.file = await getDocument(id);

        this.signedFile = null;
        this.signedFile = await getSignedDoc(id);
      }
    },
    openShareModal() {
      this.$modal.show(this.shareModalId);
    },
    async signShare(data) {
      try {
        this.isLoading = true;
        await sendInviteEmail(data);
        this.$toastr("success", "Запрошення відправлено");
      } catch (e) {
        this.$toastr("error", `Запрошення не відправлено. ${e.message}`);
      } finally {
        this.isLoading = false;
      }
    },
    async sendToEmail() {
      try {
        this.isLoading = true;
        await sendFilesToEmail(this.session.token);
        this.$toastr("success", "Документи відправлено");
      } catch (e) {
        this.$toastr("error", `Документи не відправлено. ${e.message}`);
      } finally {
        this.isLoading = false;
      }
    },
    triggerSignActiveDocument() {
      this.signFunction = data => this.signDocument(data, this.activeDocument);

      this.signOrShowModal();
    },
    triggerSignAllDocuments() {
      this.signFunction = data => this.signAllDocuments(data);

      this.signOrShowModal();
    },
    signOrShowModal() {
      // check if modal submit needed. Reuse key and pass after first sign
      if (this.signSuccess && this.signData) {
        this.signFunction(this.signData);
      } else {
        this.$modal.show(this.signModalId);
      }
    },
    async signDocument(data, document, updateOnDone = true) {
      try {
        this.isLoading = true;

        this.signData = data;

        const { p7s, signatures, name: fileName } = document;

        const isSignedByUs = p7s && p7s.length > 0;
        // const isSignedByClient = signatures && signatures.length > 0;

        const file = isSignedByUs
          ? await getSignedDoc(document.id)
          : await getDocument(document.id);

        const { error, result: newSignedFile } = await signDocumentFlow({
          file,
          document,

          caId: data.caId,
          container: data.key,
          password: data.password,
        });

        if (error) {
          this.$toastr(
            "error",
            `Документ «${document.name}» не підписано. ${error}`
          );

          this.isLoading = false;
          return new Error(error);
        } else {
          const result = await uploadSignedFile(document.id, newSignedFile);

          if (updateOnDone) {
            this.documents = await getDocumentsList();
            this.checkIsAllSigned();
          }

          this.$modal.hide(this.signModalId);
          this.signSuccess = true;
          this.$toastr("success", `Документ «${document.name}» підписано`);

          this.isLoading = false;
          return result;
        }
      } catch (e) {
        this.$toastr("error", e.message);

        Sentry.captureException(e)
      } finally {
        this.isLoading = false;
      }
    },
    async signAllDocuments(data) {
      try {
        this.isLoading = true;

        const results = await Promise.all(
          this.documents.map((document) =>
            this.signDocument(data, document, false)
          )
        );

        this.documents = await getDocumentsList(this.ref);
        this.checkIsAllSigned();
      } catch (e) {
        this.$toastr("error", e.message);
      } finally {
        this.isLoading = false;
      }
    },
    downloadSigned() {
      const isSigned = this.isActiveDocumentSigned;
      const href = isSigned ? this.signedFileUri : this.fileUri;

      const { name, p7s } = this.activeDocument;

      const signedName =
        (p7s && p7s[0] && p7s[0].attr && p7s[0].attr.name) || name;

      const a = document.createElement("a");
      a.href = href;
      a.download = signedName;

      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    async checkIsAllSigned() {
      if (this.isAllSigned) {
        this.signData = null; // clear form data if user signed

        await statusChange(22); // DM-450: 22 - Подписано клиентом
      }
    },
    async handleDocumentsSubmit() {
      this.submitted = true;

      if (this.isAllSigned) {
        await statusChange(22); // DM-450: 22 - Подписано клиентом

        this.showAllSigned = this.isAllSigned;
      }
    },
    async getSession() {
      try {
        this.session = await getSession(this.ref);

        if (this.session.token) {
          this.init();
        } else {
          !Number(sessionStorage.getItem('otpTimer')) ? await this.otpSignRequest() : this.otpMessage = 'OTP пароль можна отримати 1 раз в 60 секунд';
          this.$modal.show(this.otpModalId);
        }
      } catch (e) {
        console.error(e);
        this.$toastr("error", e.message);
      }
    },
    async otpSignRequest() {
      try {
        this.isLoading = true;
        const {
          otp_ref: otpRef,
          // otp_expired,
          message: otpMessage,
        } = await requestOtp(this.ref);

        this.otpRef = otpRef;
        this.otpMessage = otpMessage;
      } catch (e) {
        // console.error(e);
        this.$toastr("error", e.message);
      } finally {
        this.isLoading = false;
      }
    },
    async optSignConfirm({ code }) {
      try {
        this.isLoading = true;

        this.session.token = await requestOtpConfirmation(
          this.ref,
          this.otpRef,
          code
        );
        saveSession(this.session);

        this.$modal.hide(this.otpModalId);
        this.init();
      } catch (e) {
        // console.error(e);
        this.$toastr("error", e.message);
      } finally {
        this.isLoading = false;
      }
    },
    async init() {
      try {
        const { query } = this.$route;
        this.isLoading = true;

        // DM-450 - status change on user visit
        await statusChange(21); // 21 - На подписании у клиента

        this.documents = await getDocumentsList();

        if (this.documents && this.documents.length > 0) {
          this.documentSelect(this.documents[0].id);
        }

        this.authorities = await getCertificateAuthorities();
      } catch (e) {
        this.$toastr("error", e.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
  data() {
    return {
      ref: null,
      isManager: false,

      documents: [],
      activeId: null,
      signFunction: this.signDocument,

      file: null,
      signedFile: null,

      signSuccess: false,
      signData: null,

      authorities: [],

      isLoading: false,
      showAllSigned: false,

      signModalId: SIGN_MODAL_ID,
      shareModalId: SHARE_MODAL_ID,
      otpModalId: OTP_MODAL_ID,

      session: null,

      otpRef: null,
      otpMessage: null,

      submitted: false,
    };
  },
  async created() {
    try {
      const { params } = this.$route;
      this.ref = params.id;
      this.isLoading = true;

      await this.getSession();
    } catch (e) {
      this.$toastr("error", e.message);
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped lang='less'>
.container {
  display: flex;
  flex-flow: row nowrap;
}
.sidebar {
  width: 456px;
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
  flex-shrink: 0;
}
.sidebar-content {
  padding: 56px 40px 350px 40px;
  padding-bottom: 350px;
  box-sizing: border-box;
}
.content {
  flex-grow: 1;
  height: 100vh;
  overflow-y: auto;
}
.sidebar .header,
.tab-bar {
  margin-bottom: 56px;
}
.btn {
  width: 100%;
  margin-top: 10px;
}
.add-people {
  margin: 12px 0 40px 0;
  color: var(--main-base);
  border: 1px solid var(--second-base);

  path {
    stroke: var(--main-base);
  }

  &:hover {
    color: var(--main-hover);

    path {
      stroke: var(--main-hover);
    }
  }

  &:focus {
    color: var(--main-pressed);

    path {
      stroke: var(--main-pressed);
    }
  }
}
.loader {
  position: fixed;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  pointer-events: none;
}
.main-title {
  display: block;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--grey-230);
}
</style>
